import { render, staticRenderFns } from "./ProductDetailSection.vue?vue&type=template&id=56e45b40&scoped=true"
import script from "./ProductDetailSection.vue?vue&type=script&lang=js"
export * from "./ProductDetailSection.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailSection.vue?vue&type=style&index=0&id=56e45b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e45b40",
  null
  
)

export default component.exports